module.exports = __webpack_public_path__ + "static/media/injuredHold.1c665604.mp3";